import { Phone, MapPin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const BUSINESS_PHONE_LINK = "tel:+33549057490";
const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/104+Rue+de+la+Gare,+79000+Niort,+France";
const WHATSAPP_URL = "https://wa.me/33549057490?text=Bonjour,%20je%20souhaite%20des%20informations%20sur%20vos%20services%20de%20réparation.";

export const StickyMobileBar = () => {
  return (
    <div className="sticky-mobile-bar md:hidden" data-testid="sticky-mobile-bar">
      <a href={BUSINESS_PHONE_LINK} className="flex-1">
        <Button 
          className="w-full bg-blue-600 hover:bg-blue-700 h-12 text-base font-semibold gap-2"
          data-testid="sticky-call-btn"
        >
          <Phone className="h-5 w-5" />
          Appeler
        </Button>
      </a>
      
      <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex-1">
        <Button 
          variant="outline" 
          className="w-full h-12 text-base font-semibold gap-2 border-slate-300"
          data-testid="sticky-map-btn"
        >
          <MapPin className="h-5 w-5" />
          Itinéraire
        </Button>
      </a>

      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
        <Button 
          variant="outline" 
          className="h-12 w-12 p-0 border-green-500 text-green-600 hover:bg-green-50"
          data-testid="sticky-whatsapp-btn"
        >
          <MessageCircle className="h-5 w-5" />
        </Button>
      </a>
    </div>
  );
};
